export default __webpack_public_path__ + "7e800ba283ba137a3805db47db0b1fd4.png";